<template>
    <div class="section-box">
        <el-tabs v-model="seaType" type="card" class="customer-tabs-mg">
            <el-tab-pane v-for="(item, index) in titleCourse" :label="item.value" :name="item.key + ''" :key="index">
            </el-tab-pane>
        </el-tabs>
        <div class="customer-list">
            <div class="next-button" v-if="
          !(
            typeof actionData.customerghkh_add != 'undefined' &&
            !actionData.customerghkh_add
          )
        ">
                <el-button size="small" type="primary" icon="el-icon-plus" plain @click="checkCouseDetail(false)">新建
                </el-button>
                <el-button size="small" type="primary" @click="GetMatterList()">查询</el-button>
                <el-button size="small" type="success" @click="resetSearch()">重置</el-button>
            </div>
        </div>

        <el-table :stripe="true" :data="tableData" style="width: 100%; margin-top: 20px" height="590" border
            v-loading="listLoading">
            <!-- eslint-disable  -->
            <el-table-column label="素材编号">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.mediaNo" placeholder="输入关键字搜索" @change="GetMatterList()" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.smediaNo || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="素材名称">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.mediaName" placeholder="输入关键字搜索"
                            @change="GetMatterList()" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.smediaName || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="素材类别">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" placeholder="请选择" v-model="form.matterType" style="width: 100%"
                            @change="GetMatterList()" filterable>
                            <el-option value="" label="请选择"></el-option>
                            <el-option v-for="(item, index) in paperList" :value="item.key" :label="item.value"
                                :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.smediaType || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="领域">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" placeholder="请选择" v-model="form.domin" style="width: 100%"
                            @change="getProductAndList(form.domin, 'matterList')" filterable>
                            <el-option value="" label="请选择"></el-option>
                            <el-option v-for="(item, index) in dominArr" :value="item.domainid" :label="item.domainname"
                                :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.sdomain || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="产品">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" placeholder="请选择" v-model="form.productId" style="width: 100%"
                            @change="GetMatterList()" filterable>
                            <el-option value="" label="请选择"></el-option>
                            <el-option v-for="(item, index) in productSelectArr" :value="item.key" :label="item.value"
                                :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.sproduct || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="品牌">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" placeholder="请选择" v-model="form.brandId" style="width: 100%"
                            @change="GetMatterList()" filterable>
                            <el-option value="" label="请选择"></el-option>
                            <el-option v-for="(item, index) in brandArr" :value="item.key" :label="item.value"
                                :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.sbrand || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="更新时间">
                <el-table-column show-overflow-tooltip width="250">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker size="mini" v-model="form.EffectivityTime" type="daterange" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" range-separator="—" start-placeholder="开始日期"
                            end-placeholder="结束日期" style="width: 100%" @change="GetMatterList()"></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.dupdateDate || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="备注" show-overflow-tooltip>
                <!-- <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.smediaRemark" placeholder="输入关键字搜索" @change="GetMatterList()" />
                    </template> -->
                    <template slot-scope="scope">
                        <span>{{ scope.row.smediaRemark || "--" }}</span>
                    </template>
                <!-- </el-table-column> -->
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button @click="checkCouseDetail(scope.row.pkid)" type="primary" size="mini">详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px; overflow: hidden">
            <div style="float: right" v-show="tableData.length">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="form.pageNum" :page-sizes="[10, 20, 50, 100, 200]" :page-size="form.pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>

        <el-dialog :title="editTitle" :visible.sync="isDetail" width="600px" :destroy-on-close="true"
            :close-on-click-modal="false" :before-close="handleClose" top="3%" v-loading="isLoading">
            <el-form :label-position="labelPosition" label-width="80px" :model="matterAddForm" :rules="rules"
                ref="matterAddForm" class="addPaper" >
                <el-form-item label="上传文件" class="videoIcon">
                    <!-- :action="url" 
                        :show-file-list="false"
                        :on-success="handleVideoSuccess" 
                        list-type="picture-card" accept=".mp4,.PDF"
                        :before-upload="beforeUploadVideo" 
                        :on-progress="uploadVideoProcess" -->
                    <el-upload class="avatar-uploader el-upload--text" action :http-request="Upload"
                        :before-upload="beforeAvatarUpload" :on-preview="handlePreview" :before-remove="beforeRemove"
                        :on-remove="handleRemove" :on-success="handleSuccess" drag :file-list="fileList"
                        :show-file-list="false">
                        <span class="timeDom"
                            v-if="videoForm.Video != '' && videoFlag == false && meidaType == 'mp4' && matterAddForm.stimeSpan != '0'"><img
                                src="@/assets/video.png" alt="" class="videoIcon2"><b
                                v-text="resultFormat(matterAddForm.stimeSpan)"></b></span>
                        <video v-if="videoForm.Video != '' && videoFlag == false && meidaType == 'mp4'"
                            :src="videoForm.Video" class="avatar" controls="controls">
                            您的浏览器不支持视频播放
                        </video>

                        <img src="../../assets/icon/icon_pdf.jpg"
                            v-else-if="videoForm.Video != '' && videoFlag == false && meidaType == 'pdf'" />
                        <i v-else-if="videoForm.Video == '' && videoFlag == false"
                            class="el-icon-plus avatar-uploader-icon"></i>
                        <!-- videoUploadPercent -->
                        <el-progress v-if="videoFlag == true" type="circle" :percentage="progress"
                            style="margin-top: 10px"></el-progress>
                    </el-upload>
                    <el-button size="mini" type="danger" v-if="videoForm.Video"
                        @click="videoForm.Video = '';videoForm.videoUploadId = '';">删除文件重新上传
                    </el-button>
                    <span class="tipsCls">注：大小在10G以下，仅支持MP4或PDF格式</span>
                </el-form-item>
                <el-form-item label="素材名称" prop="name">
                    <el-input v-model="matterAddForm.name" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="素材类别" prop="type">
                    <el-select v-model="matterAddForm.type" filterable placeholder="请选择" style="width: 100%" filterable>
                        <el-option v-for="(item, index) in paperList" :value="item.key" :label="item.value"
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="素材备注" prop="smediaRemark">
                    <el-input v-model="matterAddForm.smediaRemark" placeholder="请输入" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="领域">
                    <el-select v-model="matterAddForm.domainId" filterable placeholder="请选择" style="width: 100%"
                        @change="getProductAndList(matterAddForm.domainId)">
                        <el-option value="" label="请选择"></el-option>
                        <el-option v-for="(item, index) in dominArr" :value="item.domainid" :label="item.domainname"
                            :key="index" filterable>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="产品">
                    <el-select v-model="matterAddForm.productId" filterable placeholder="请选择" style="width: 100%"
                        filterable>
                        <el-option value="" label="请选择"></el-option>
                        <el-option v-for="(item, index) in productSelectArr" :value="item.key" :label="item.value"
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="品牌">
                    <el-select v-model="matterAddForm.brandId" filterable placeholder="请选择" style="width: 100%"
                        filterable>
                        <el-option value="" label="请选择"></el-option>
                        <el-option v-for="(item, index) in brandArr" :value="item.key" :label="item.value" :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="行业">
                    <el-select v-model="matterAddForm.industryId" filterable placeholder="请选择" style="width: 100%">
                        <el-option value="" label="请选择"></el-option>
                        <el-option v-for="item in industryArr" :key="item.value" :label="item.industryname"
                            :value="item.industryid">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="难度">
                    <el-select v-model="matterAddForm.difficultyLevelId" filterable placeholder="请选择"
                        style="width: 100%">
                        <el-option value="" label="请选择"></el-option>
                        <el-option v-for="item in difficultyLevelArr" :key="item.value" :label="item.value"
                            :value="item.key">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="delMatter()" type="danger" v-if="submitFormId.pkid">删除</el-button>
                <el-button type="primary" @click="submitForm('matterAddForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import {
        Decrypt
    } from "@/utils/crypto";
    import {
        client,
        getFileNameUUID
    } from "@/utils/ali-oss"; //前面的ali-js文件内的两个封装函数
    import {
        matterList,
        matterTypeList,
        dominList,
        brandList,
        industryList,
        difficultyLevelList,
        matterDeatil,
        submitMatter,
        productSelectList,
        delCourseMedia,
    } from "@/service/courseListApi";
    import {
        getActionData
    } from "@/utils/store";

    export default {
        components: {},
        data() {
            return {
                actionData: JSON.parse(getActionData()), //功能按钮每个页面必须用
                titleCourse: [],
                listLoading: false,
                form: {
                    matterType: "",
                    domin: "",
                    pageNum: 1,
                    pageSize: 10,
                    mediaNo: null,
                    mediaName: "",
                    brandId: null,
                    EffectivityTime: [],
                    productId: null,
                    smediaRemark: '', //备注接口暂无
                },
                seaType: '1',
                oraginForm: {},
                total: 0, //总条数

                tableData: [],
                paperList: [],
                dominArr: [],
                brandArr: [],
                // 角标
                count0: 1,
                count1: 2,
                count2: 3,
                isDetail: false,
                labelPosition: "right",

                url: "",
                matterAddForm: {
                    name: "",
                    type: "",
                    domainId: "",
                    productId: "",
                    brandId: "",
                    industryId: "",
                    difficultyLevelId: "",
                    stimeSpan: 0,
                    smediaRemark: '',       //素材备注 编辑新增
                },
                rules: {
                    name: [{
                        required: true,
                        message: "请输入素材名称",
                        trigger: "blur",
                    }, ],
                    type: [{
                        required: true,
                        message: "请选择活动区域",
                        trigger: "change",
                    }, ],
                },
                difficultyLevelArr: [],
                industryArr: [],
                productSelectArr: [],
                submitFormId: {},
                //s upload
                videoForm: {
                    Video: "",
                    videoUploadId: "",
                },
                videoFlag: false,
                videoUploadPercent: 0,
                //e upload
                editTitle: "",
                flageChangeWhList: "",
                meidaType: "pdf",

                // limit:1,
                // 大文件上传
                fileList: [], //文件列
                //   showProgress: false,//进度条的显示
                progress: 0, //进度条数据
                //大文件上传      

                isLoading:false,
            };
        },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form));
            this.tableData = [];
            this.getTitle();
            this.GetMatterList();
            let api =
                process.env.NODE_ENV == "development" ?
                "/api1" :
                process.env.VUE_APP_API1;
            this.url = api + "/api/Upload/UploadNoWaterVideo";
            // this.url = api + "/api/Upload/MultipartUploadOSSFile";

            this.getMatterType();
            this.getDominList();
            this.getBrandList();
            this.getDifficultyLevelList();
            this.getIndustryList();
        },

        methods: {
            resultFormat(t) {
                var value = parseInt(t)
                var h = Math.floor(value / 3600);
                var m = Math.floor((value / 60 % 60));
                var s = Math.floor((value % 60));
                if (h < 1) {
                    h = '00'
                }
                if (m < 9) {
                    m = '0' + m
                }
                if (s < 10) {
                    s = '0' + s
                }
                return h + ':' + m + ':' + s
            },
            //大文件上传
            // 文件超出个数限制时的钩子
            // handleExceed(files, fileList) {

            //   this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
            // },

            // 点击文件列表中已上传的文件时的钩子
            handlePreview(file) {

            },

            // 删除文件之前的钩子
            beforeRemove(file, fileList) {

                // return this.$confirm(`确定移除 ${file.name}？`);
            },

            // 文件列表移除文件时的钩子
            handleRemove(file, fileList) {

            },

            // 文件上传成功时的钩子
            handleSuccess(response, file, fileList) {

                this.fileList = fileList;
            },

            //文件上传前的校验
            beforeAvatarUpload(file) {
                const _this = this
                const isLt10M =  file.size/1024/1024/1024<10;
                var fileName = file.name || "";
                var ext = fileName.split(".")[fileName.split(".").length - 1];
                if (
                    [
                        "video/mp4",
                        "video/ogg",
                        "video/flv",
                        "video/avi",
                        "video/wmv",
                        "video/rmvb",
                        "application/pdf",
                        "application/x-pdf",
                    ].indexOf(file.type) == -1
                ) {
                    this.$message.error("请上传正确的视频格式");
                    return false;
                }
                if (!isLt10M) {
                    this.$message.error("上传视频大小不能超过10G哦!");
                    return false;
                }
                if (ext == "mp4" || ext == "MP4") {
                    // 获取视频时长
                    var url = URL.createObjectURL(file);
                    var audioElement = new Audio(url);
                    var duration;
                    audioElement.addEventListener("loadedmetadata", function (_event) {
                        duration = audioElement.duration; //时长为秒，小数，182.36
                        _this.matterAddForm.stimeSpan = parseInt(duration);
                    });
                }
            },
            // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现 
            Upload(file) {
                const config = {
                    region: "oss-cn-zhangjiakou",
                    accessKeyId: "LTAIm1hXML86TVS4",
                    accessKeySecret: "TsgBJS0oD3V0YBkYs6P8XnFVo0GH1O",
                    bucket: "gk-manager",
                };
                //https://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/videoTest/1626272056386_08a983d9.rar
                const that = this;
                async function multipartUpload() {
                    let temporary = file.file.name.lastIndexOf(".");
                    let fileNameLength = file.file.name.length;
                    let fileFormat = file.file.name.substring(
                        temporary + 1,
                        fileNameLength
                    );
                    let fileName = getFileNameUUID() + "." + fileFormat;
                    client(config)
                        .multipartUpload(`video/${fileName}`, file.file, {
                            progress: function (p) {
                                //p进度条的值
                                // console.log(p);
                                that.videoFlag = true;
                                // that.showProgress = true;
                                that.progress = Math.floor(p * 100);
                            }
                        })
                        .then(result => {
                            //上传成功返回值，可针对项目需求写其他逻辑
                            // console.log(result);
                            // console.log(result.res.requestUrls[0]);
                            that.videoFlag = false;
                            that.videoUploadPercent = 0;
                            var totalUrl = result.res.requestUrls[0];
                            that.videoForm.videoUploadId = that.getQueryVariable(totalUrl,
                                'uploadId'); //oss没有返回id
                            that.videoForm.Video = totalUrl.split("?")[0]
                            var temp = that.videoForm.Video.substring(that.videoForm.Video.lastIndexOf(".") +
                                1);
                            if (temp == "pdf" || temp == "PDF") {
                                that.meidaType = "pdf";
                            } else {
                                that.meidaType = "mp4";
                            }
                        })
                        .catch(err => {
                            that.$message.error(err)
                        });
                }
                multipartUpload();
            },
            getQueryVariable(url, paraName) {
                var arrObj = url.split("?");
                if (arrObj.length > 1) {
                    var arrPara = arrObj[1].split("&");
                    var arr;
                    for (var i = 0; i < arrPara.length; i++) {
                        arr = arrPara[i].split("=");
                        if (arr != null && arr[0] == paraName) {
                            return arr[1];
                        }
                    }
                    return "";
                } else {
                    return "";
                }
            },
            //大文件上传
            resetSearch() {
                this.form = {
                    matterType: "",
                    domin: "",
                    pageNum: 1,
                    pageSize: 10,
                    mediaNo: null,
                    mediaName: "",
                    brandId: null,
                    EffectivityTime: [],
                    productId: null,
                }
                this.GetMatterList()
            },
            getProductAndList(id, type, apiId) {
                this.flageChangeWhList = type;
                this.$nextTick(() => {
                    this.getProductSelectList(id, apiId);
                });
            },
            getProductSelectList(id, apiId) {
                const _this = this;
                productSelectList(id, apiId).then((r) => {
                    if (r.Result == 1) {
                        _this.productSelectArr = [];
                        _this.productSelectArr = r.Data || [];
                        _this.$forceUpdate();
                        if (_this.flageChangeWhList == "matterList") {
                            _this.form.productId = "";
                            _this.GetMatterList();
                            return;
                        } else if (_this.flageChangeWhList == "api") {
                            this.matterAddForm.productId = apiId;
                        } else {
                            _this.matterAddForm.productId = "";
                        }
                    }
                });
            },
            //s上传

            // beforeUploadVideo(file) {
            //     const isLt10M = file.size / 1024 / 1024 < 10000;
            //     if (
            //         [
            //             "video/mp4",
            //             "video/ogg",
            //             "video/flv",
            //             "video/avi",
            //             "video/wmv",
            //             "video/rmvb",
            //             "application/pdf",
            //             "application/x-pdf",
            //         ].indexOf(file.type) == -1
            //     ) {
            //         this.$message.error("请上传正确的视频格式");
            //         return false;
            //     }
            //     if (!isLt10M) {
            //         this.$message.error("上传视频大小不能超过10G哦!");
            //         return false;
            //     }
            // },

            // uploadVideoProcess(event, file, fileList) {
            //     this.videoFlag = true;
            //     this.videoUploadPercent = Number(file.percentage.toFixed(0));
            // },
            // handleVideoSuccess(res, file) {
            //     //获取上传图片地址
            //     this.videoFlag = false;
            //     this.videoUploadPercent = 0;
            //     if (res.Result == 1) {
            //         this.videoForm.videoUploadId = res.Data[0].FileId;
            //         this.videoForm.Video = res.Data[0].FileUrl;
            //         var temp = this.videoForm.Video.substring(this.videoForm.Video.lastIndexOf(".") + 1);
            //             if (temp == "pdf" || temp == "PDF") {
            //                 this.meidaType = "pdf";
            //             } else {
            //                 this.meidaType = "mp4";
            //             }
            //     } else {
            //         this.$message.error("视频上传失败，请重新上传！");
            //     }
            // },
            //e上传
            getDifficultyLevelList() {
                difficultyLevelList().then((r) => {
                    if (r.Result == 1) {
                        this.difficultyLevelArr = r.Data || [];
                    }
                });
            },
            getIndustryList() {
                industryList().then((r) => {
                    if (r.Result == 1) {
                        this.industryArr = r.Data || [];
                    }
                });
            },
            checkCouseDetail(id) {
                this.productSelectArr = [];
                if (!id) {
                    this.editTitle = "新建素材";
                    this.matterAddForm = {
                        name: "",
                        type: "产品培训",
                        domainId: "",
                        productId: "",
                        brandId: "",
                        industryId: "",
                        difficultyLevelId: "",
                        stimeSpan: 0,
                        smediaRemark: '',
                    };
                    this.videoForm.Video = "";
                    this.videoFlag = false;
                    this.submitFormId.nmediaTypeId = "1";
                    this.isDetail = true;
                    return;
                }
                if (id) {
                    this.editTitle = "素材详情";
                    this.pkid = id;
                    this.getDetail(id);
                }
            },
            async getDetail(id) {
                var data = {
                    pkid: id,
                };
                let res = await matterDeatil(data);
                let detail = res.Data;
                if (res.Result == 1) {
                    this.matterAddForm = {
                        name: detail.smediaName,
                        type: detail.smediaType,
                        domainId: detail.ndomainId,
                        productId: detail.nproductId,
                        brandId: detail.sbrand,
                        industryId: detail.strade,
                        difficultyLevelId: detail.sdifficultyLevel,
                        stimeSpan: detail.stimeSpan,
                        smediaRemark: detail.smediaRemark
                    };
                    this.submitFormId = {
                        nbrandId: detail.nbrandId,
                        ndifficultyLevelId: detail.ndifficultyLevelId,
                        ndomainId: detail.ndomainId,
                        nmediaTypeId: detail.nmediaTypeId,
                        nproductId: detail.nproductId,
                        ntradeId: detail.ntradeId,
                        pkid: detail.pkid,
                        stimeSpan: detail.stimeSpan,
                        smediaRemark: detail.smediaRemark
                    };
                    if (detail.sfileUrl) {
                        var enC = Decrypt(detail.sfileUrl)
                        this.videoForm.Video = enC;
                        this.videoFlag = false;
                        var temp = enC.substring(enC.lastIndexOf(".") + 1);
                        if (temp == "pdf" || temp == "PDF") {
                            this.meidaType = "pdf";
                        } else {
                            this.meidaType = "mp4";
                        }
                    }
                    if (this.matterAddForm.domainId)
                        this.getProductAndList(
                            this.matterAddForm.domainId,
                            "api",
                            detail.sproduct
                        );

                    this.isDetail = true;
                }
            },
            getMatterType() {
                matterTypeList().then((r) => {
                    if (r.Result == 1) {
                        this.paperList = r.Data || [];
                    }
                });
            },
            getDominList() {
                dominList().then((r) => {
                    if (r.Result == 1) {
                        this.dominArr = r.Data || [];
                    }
                });
            },
            getBrandList() {
                brandList().then((r) => {
                    if (r.Result == 1) {
                        this.brandArr = r.Data || [];
                    }
                });
            },
            delMatter() {
                this.$confirm("是否确定删除整个素材?", "提示", {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var data = {
                        pkid: this.pkid,
                    };
                    delCourseMedia(data).then((r) => {
                        if (r.Result == 1) {
                            this.$message.success("删除成功");
                            this.isDetail = false;
                            for (let key in this.matterAddForm) {
                                delete this.matterAddForm[key];
                            }
                            this.handleClose();
                            this.GetMatterList();
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });


            },
            submitForm(formName) {
                const _this = this;
                
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (!this.videoForm.Video) {
                            this.$message.error("请先上传视频或者pdf");
                            return;
                        }
                        var data = {
                            nbrandId: _this.isNumType(_this.matterAddForm.brandId) ? _this.matterAddForm
                                .brandId : _this.submitFormId.nbrandId,
                            ndifficultyLevelId: _this.isNumType(
                                    _this.matterAddForm.difficultyLevelId
                                ) ?
                                _this.matterAddForm.difficultyLevelId : _this.submitFormId
                                .ndifficultyLevelId,
                            ndomainId: _this.isNumType(_this.matterAddForm.domainId) ?
                                _this.matterAddForm.domainId : _this.submitFormId.ndomainId,
                            nmediaTypeId: _this.isNumType(_this.matterAddForm.type) ?
                                _this.matterAddForm.type : _this.submitFormId.nmediaTypeId,
                            nproductId: _this.isNumType(_this.matterAddForm.productId) ?
                                _this.matterAddForm.productId : _this.submitFormId.nproductId,
                            ntradeId: _this.isNumType(_this.matterAddForm.industryId) ?
                                _this.matterAddForm.industryId : _this.submitFormId.ntradeId,
                            pkid: _this.submitFormId.pkid ? _this.submitFormId.pkid : "",
                            sfileUrl: this.videoForm.Video,
                            smediaName: _this.matterAddForm.name,
                            smediaRemark: _this.matterAddForm.smediaRemark
                        };
                        if (_this.meidaType == "mp4") {
                            if (_this.matterAddForm.stimeSpan > 0) {
                                data.stimeSpan = this.matterAddForm.stimeSpan
                            } else {
                                data.stimeSpan = this.submitFormId.stimeSpan
                            }

                        }
                        this.isLoading = true
                        if(!this.isLoading) return
                        submitMatter(data).then((r) => {
                            _this.isLoading = false
                            if (r.Result == 1) {
                                _this.$message.success("保存成功");
                                _this.resetForm("matterAddForm");
                                _this.handleClose();
                                _this.GetMatterList();
                            }
                        });
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            },
            handleClose() {
                this.resetForm("matterAddForm");
                if (this.submitFormId.pkid) delete this.submitFormId.pkid;
                this.isDetail = false;
            },
            isNumType(n) {
                var nn = Number(n);
                if (!isNaN(nn)) {
                    return true;
                }
                return false;
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            getTitle() {
                this.titleCourse = [{
                    key: 1,
                    value: "课程素材",
                }, ];
            },
            async GetMatterList() {
                this.listLoading = true;
                var data = {
                    pageNum: this.form.pageNum,
                    pageSize: this.form.pageSize,
                    rational: false,
                };
                if (
                    this.form.EffectivityTime instanceof Array &&
                    this.form.EffectivityTime.length > 0
                ) {
                    data.dupdateDateBegin = this.form.EffectivityTime[0] + " 00:00:00";
                    data.dupdateDateEnd = this.form.EffectivityTime[1] + " 23:59:59";
                } else {
                    if (data.dupdateDateBegin) delete data.dupdateDateBegin;
                    if (data.dupdateDateEnd) delete data.dupdateDateEnd;
                }
                if (this.form.brandId) data.nbrandId = this.form.brandId;
                if (this.form.domin) data.ndomainId = this.form.domin;
                if (this.form.matterType) data.nmediaTypeId = this.form.matterType;
                if (this.form.productId) data.nproductId = this.form.productId;
                if (this.form.mediaNo) data.smediaNo = this.form.mediaNo;
                if (this.form.mediaName) data.smediaName = this.form.mediaName;

                let res = await matterList(data);
                this.listLoading = false;
                if (res.Result != 1) {
                    return this.$message.error("获取失败请联系开发人员");
                }
                this.tableData = res.Data.datas;
                this.total = res.Data.total;
            },
            handleSizeChange(val) {
                if (this.listLoading) return;
                this.form.pageNum = 1;
                this.form.pageSize = val;
                this.GetMatterList();
            },
            handleCurrentChange(val) {
                if (this.listLoading) return;
                this.form.pageNum = val;
                this.GetMatterList();
            },
        },
    };
</script>
<style lang="scss">
    .customer-tabs-mg {
        .el-tabs__header {
            margin: 0 0 15px !important;
        }
    }

    .customer-list {
        position: relative;

        .next-button {
            position: absolute;
            right: 0;
            top: -56px;
        }
    }

    .customer-row-bg {
        padding: 20px 14px;
        background-color: #f9fafc;
        display: flex;
        align-items: center;

        .el-form-item {
            margin-bottom: 0 !important;
        }

        .selected {
            color: #409eff;
            border-color: #c6e2ff;
            background-color: #ecf5ff;
        }
    }

    .linkInfo {
        cursor: pointer;

        &:hover {
            color: #409eff;
        }
    }

    .addPaper {
        .el-form-item {
            margin-bottom: 20px !important;
        }
    }

    .avatar,
    .el-upload-dragger {
        width: 148px;
        height: 148px;
    }

    .tipsCls {
        margin-left: 10px;
    }

    .videoIcon .el-form-item__label::before {
        content: "* ";
        color: red;
    }

    .avatar-uploader-icon {
        margin-top: 67px;
    }

    .timeDom {
        display: block;
        position: absolute;
        padding: 2px;
        color: #fff;
        top: 0;
        right: 0;
        z-index: 999;
        background: #000;

        .videoIcon2 {
            height: 18px;
            width: auto;
            vertical-align: text-bottom;
            margin-left: 5px;
        }
    }
</style>